var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.form === 1)?[_c('basic-form')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }